import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function AGB() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#6B6B6B] hover:text-primary transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-[#1A1A1A] mb-2">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="text-[#6B6B6B] mb-8">Stand: April 2026</p>

        <section className="space-y-8">
          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 1 Geltungsbereich</h2>
            <p className="text-[#6B6B6B]">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen der MAMAL GmbH
              (nachfolgend „MAMAL" oder „Anbieter") und den Nutzern der MAMAL-Plattform (nachfolgend „Nutzer").
              Abweichende Bedingungen des Nutzers werden nicht anerkannt, es sei denn, MAMAL stimmt ihrer Geltung
              ausdrücklich schriftlich zu.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 2 Leistungsbeschreibung</h2>
            <p className="text-[#6B6B6B] mb-2">
              MAMAL ist eine SaaS-Plattform für selbstständige Berater und Vertriebspartner im
              Direktvertrieb-Bereich. Die Plattform bietet folgende Kernfunktionen:
            </p>
            <ul className="list-disc list-inside text-[#6B6B6B] space-y-1 ml-2">
              <li>CRM und Lead-Management</li>
              <li>Formular-Builder zur Lead-Generierung</li>
              <li>Website-Builder für persönliche Landing Pages</li>
              <li>Analytics und Tracking</li>
              <li>KI-Assistent für die tägliche Arbeit</li>
              <li>Medien-Verwaltung</li>
            </ul>
            <p className="text-[#6B6B6B] mt-2">
              Der Anbieter behält sich vor, den Leistungsumfang jederzeit zu ändern, zu erweitern oder einzuschränken,
              sofern dies dem Nutzer mit angemessener Frist mitgeteilt wird.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 3 Vertragsschluss und Registrierung</h2>
            <p className="text-[#6B6B6B] mb-2">
              3.1 Die Nutzung der MAMAL-Plattform setzt eine Registrierung voraus. Mit der Registrierung gibt der
              Nutzer ein verbindliches Angebot zum Abschluss eines Nutzungsvertrags ab.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              3.2 Der Nutzer muss bei der Registrierung wahrheitsgemäße Angaben machen und diese aktuell halten.
            </p>
            <p className="text-[#6B6B6B]">
              3.3 Der Nutzer ist verpflichtet, seine Zugangsdaten geheim zu halten und vor dem Zugriff Dritter zu
              schützen. Bei Missbrauch oder Verdacht auf Missbrauch ist MAMAL unverzüglich zu informieren.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 4 Nutzungsrechte</h2>
            <p className="text-[#6B6B6B] mb-2">
              4.1 MAMAL räumt dem Nutzer für die Dauer des Vertrags ein nicht-exklusives, nicht übertragbares
              Recht zur Nutzung der Plattform ein.
            </p>
            <p className="text-[#6B6B6B]">
              4.2 Die Nutzung ist ausschließlich für eigene berufliche Zwecke des Nutzers gestattet. Eine
              Weitergabe von Zugangsdaten oder Unterlizenzen an Dritte ist nicht erlaubt.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 5 Pflichten des Nutzers</h2>
            <p className="text-[#6B6B6B] mb-2">Der Nutzer verpflichtet sich:</p>
            <ul className="list-disc list-inside text-[#6B6B6B] space-y-1 ml-2">
              <li>die Plattform nicht für rechtswidrige Zwecke zu nutzen</li>
              <li>keine Inhalte hochzuladen, die gegen geltendes Recht, Rechte Dritter oder die guten Sitten verstoßen</li>
              <li>keine Schadsoftware oder schädlichen Code zu verbreiten</li>
              <li>keine automatisierten Abfragen (Bots, Scraper) ohne Genehmigung durchzuführen</li>
              <li>die Systemintegrität und -verfügbarkeit nicht zu beeinträchtigen</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 6 Vergütung und Zahlung</h2>
            <p className="text-[#6B6B6B] mb-2">
              6.1 Die aktuellen Preise und Leistungspakete sind auf der Website von MAMAL einsehbar.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              6.2 Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung fällig, sofern nicht anders
              vereinbart.
            </p>
            <p className="text-[#6B6B6B]">
              6.3 Bei Zahlungsverzug ist MAMAL berechtigt, den Zugang zur Plattform zu sperren und
              Verzugszinsen in gesetzlicher Höhe zu berechnen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 7 Verfügbarkeit und Wartung</h2>
            <p className="text-[#6B6B6B] mb-2">
              7.1 MAMAL bemüht sich um eine Verfügbarkeit der Plattform von 99 % im Jahresdurchschnitt
              (ausgenommen geplante Wartungsarbeiten).
            </p>
            <p className="text-[#6B6B6B]">
              7.2 Wartungsarbeiten werden nach Möglichkeit in Zeiten geringer Nutzung durchgeführt und
              rechtzeitig angekündigt.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 8 Haftungsbeschränkung</h2>
            <p className="text-[#6B6B6B] mb-2">
              8.1 MAMAL haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der
              Gesundheit sowie für Vorsatz und grobe Fahrlässigkeit.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              8.2 Bei einfacher Fahrlässigkeit haftet MAMAL nur bei Verletzung wesentlicher Vertragspflichten und
              nur auf den vorhersehbaren, vertragstypischen Schaden.
            </p>
            <p className="text-[#6B6B6B]">
              8.3 Eine Haftung für Datenverlust besteht nur, wenn dieser nicht durch angemessene
              Datensicherungsmaßnahmen des Nutzers hätte verhindert werden können.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 9 Datenschutz</h2>
            <p className="text-[#6B6B6B]">
              Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer{' '}
              <Link to="/datenschutz" className="text-primary hover:underline">
                Datenschutzerklärung
              </Link>
              , die integraler Bestandteil dieser AGB ist.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 10 Vertragslaufzeit und Kündigung</h2>
            <p className="text-[#6B6B6B] mb-2">
              10.1 Der Vertrag wird auf unbestimmte Zeit geschlossen und kann von beiden Parteien mit einer Frist
              von 30 Tagen zum Monatsende gekündigt werden.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              10.2 Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
            </p>
            <p className="text-[#6B6B6B]">
              10.3 Nach Vertragsende werden die Daten des Nutzers gemäß gesetzlichen Aufbewahrungsfristen
              gelöscht, sofern keine anderen Vereinbarungen getroffen wurden.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 11 Änderungen der AGB</h2>
            <p className="text-[#6B6B6B]">
              MAMAL behält sich vor, diese AGB mit einer Ankündigungsfrist von mindestens 6 Wochen zu ändern.
              Änderungen werden per E-Mail mitgeteilt. Widerspricht der Nutzer nicht innerhalb von 6 Wochen,
              gelten die neuen AGB als akzeptiert.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">§ 12 Schlussbestimmungen</h2>
            <p className="text-[#6B6B6B] mb-2">
              12.1 Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              12.2 Gerichtsstand für Streitigkeiten mit Kaufleuten oder juristischen Personen des öffentlichen
              Rechts ist der Sitz von MAMAL.
            </p>
            <p className="text-[#6B6B6B]">
              12.3 Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die
              Wirksamkeit der übrigen Bestimmungen nicht.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 flex flex-wrap gap-4 justify-center text-sm text-[#6B6B6B]">
          <Link to="/impressum" className="hover:text-primary transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-primary transition-colors">Datenschutz</Link>
          <Link to="/agb" className="hover:text-primary transition-colors font-medium">AGB</Link>
        </div>
      </footer>
    </div>
  );
}
